import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const FORM_INITIAL_STATE = {
  'loading': false,
  'values': {
    'mailGroup': '',
    'description': '',
  },
};

export const mailGroupForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.FETCHING_MAIL_GROUP_INFO_BY_GROUP]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_MAIL_GROUP_INFO_BY_GROUP]: (state, action) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        ...action.response.data,
      },
    }),
    [ActionTypes.FETCHED_MAIL_GROUP_INFO_BY_GROUP_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.ADDING_NEW_GROUP_INFO]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADDED_NEW_GROUP_INFO]: (state, action) => {
      return {
        ...state,
        'loading': false,
        'values': {
          ...state.values,
          ...action.response.data,
        },
      };
    },
    [ActionTypes.ADDED_NEW_GROUP_INFO_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATING_NEW_GROUP_INFO]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_NEW_GROUP_INFO]: (state, action) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        ...action.response.data,
      },
    }),
    [ActionTypes.UPDATED_NEW_GROUP_INFO_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.SET_MAIL_GROUP_FIELD]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        [action.payload.field]: action.payload.value,
      },
    }),
    [ActionTypes.CLEAR_GROUP_INFO_FORM]: (state) => ({
      ...state,
      ...FORM_INITIAL_STATE,
    }),
  })(state, action);
};
